import axios from "axios";
import type { AuthModel, UserModel } from "./_models";
import { getAuth } from "./AuthHelpers";
import { decrypt, decryptId, encrypt } from "./crypto";

export { decrypt, decryptId, encrypt };

const API_URL = import.meta.env.VITE_APP_API_URL;

export const GET_USER_BY_ACCESSTOKEN_URL = "/auth/user";
export const LOGIN_URL = "/admin/user/login";
export const REGISTER_URL = "/register";
export const REQUEST_FORGET_PASSWORD_URL = "/auth/forgot-password";
export const REQUEST_RESET_PASSWORD_URL = "/auth/reset-password";
export const REQUEST_CAPTCHA_URL = "/captcha/generate-captcha";

// Server should return AuthModel
export async function login(
	username: string,
	password: string,
	captcha: string,
	sessionId: string,
) {
	const payload = {
		username: username,
		password: password,
		captcha: captcha,
		sessionId: sessionId,
	};
	const encryptedData = await encrypt(JSON.stringify(payload));
	return axios.post<{ status: number; data: AuthModel; message: string }>(
		LOGIN_URL,
		{
			enc: encryptedData,
		},
		{
			withCredentials: true,
		},
	);
}
// export async function getLoadCaptcha() {
// 	return axios.get(REQUEST_CAPTCHA_URL, {
// 		withCredentials: true,
// 	});
// }
export async function getLoadCaptcha() {
	return axios.get(`${REQUEST_CAPTCHA_URL}?t=${Date.now()}`, {
		withCredentials: false,
	});
}

// Server should return AuthModel
export function register(
	email: string,
	firstname: string,
	lastname: string,
	password: string,
	password_confirmation: string,
) {
	return axios.post(REGISTER_URL, {
		email,
		first_name: firstname,
		last_name: lastname,
		password,
		password_confirmation,
	});
}

export async function requestForgetPassword(
	username: string,
	mobile: string,
	captcha: string,
) {
	const payload = {
		username,
		mobile,
		captcha,
	};

	const encryptedData = await encrypt(JSON.stringify(payload));

	return axios.post<{ status: number; message: string; result?: boolean }>(
		REQUEST_FORGET_PASSWORD_URL,
		{
			enc: encryptedData,
		},
		{
			withCredentials: true,
		},
	);
}

export async function uploadUserAvatar(userId: number | string, file: File) {
	const formData = new FormData();
	formData.append("profile_picture", file);

	return axios.put<{ data: { profile_picture: string }; message: string }>(
		`/admin/users/update-profile/${userId}`,
		formData,
		{
			headers: {
				"Content-Type": "multipart/form-data",
			},
			withCredentials: true,
		},
	);
}

export function resetPassword(payload: any) {
	return axios.post<{ result: boolean }>(REQUEST_RESET_PASSWORD_URL, payload);
}

export function getUserByToken(userId?: number | string) {
	const auth = getAuth();
	const url = userId
		? `/admin/user/view/${userId}`
		: GET_USER_BY_ACCESSTOKEN_URL;

	return axios.get<UserModel>(url, {
		withCredentials: true,
		headers: {
			"Content-Type": "application/json",
			Authorization: `${auth?.access_token || auth?.token}`,
		},
	});
}
